import PropTypes from 'prop-types';

export const ribbonShape = {
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  url: PropTypes.string,
};

export const ribbonType = PropTypes.shape(ribbonShape);
